// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"c59446d8","498":"b481ac81","513":"ba65d0be","703":"622c08cc"}[chunkId] + ".chunk.js";
};